<template>
    <div class="card p-3">
        Este pedido possui desconto de {{ parseInt(faixa.valor)  }}%
        <div class="progress">            
            <div class="progress-bar progress-bar-striped bg-primary" 
                role="progressbar" 
                :style="showPercent" 
                :aria-valuenow="valor" 
                :aria-valuemin="faixa.quantidade_minima" 
                :aria-valuemax="faixa.quantidade_maxima" />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        faixa: {
            type: Object,
            default: {
                id: null,
                quantidade_minima: 0,
                quantidade_maxima: 0,
                valor: 0
            }
        },        
        valor: {
            type: Number,
            default: 0
        }
    },
    computed: {
        showPercent() {
            let percent = 0;         
            
            percent = this.faixa.valor / this.faixa.quantidade_maxima;
            //console.log("valor do percent", percent);
            //console.log("valor do desconto", this.valor);
            return 'width:' + percent + '%' ; // '+parseFloat(percent * 100).toFixed(2)+'%';
        }
    },
    data() {
        return {
            progresso: 0
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/varejo/propostas/card-desconto.vue